import { render, staticRenderFns } from "./BlockItem.vue?vue&type=template&id=4655e451&scoped=true&"
import script from "./BlockItem.vue?vue&type=script&lang=js&"
export * from "./BlockItem.vue?vue&type=script&lang=js&"
import style0 from "./BlockItem.vue?vue&type=style&index=0&id=4655e451&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4655e451",
  null
  
)

export default component.exports